/**
 * Login Modal Module
 */
export function initLoginModal() {
  const modal = document.getElementById('loginModal');
  if (!modal) return;

  const loginAlert = document.getElementById('loginAlert');
  const loginForm = document.getElementById('loginForm');

  // --- Open modal ---
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href="/login"]');
    if (!link) return;
    e.preventDefault();
    openModal();
  });

  function openModal() {
    modal.style.display = '';
    document.body.style.overflow = 'hidden';
    setTimeout(() => {
      const firstInput = modal.querySelector('input:not([type="hidden"])');
      if (firstInput) firstInput.focus();
    }, 100);
  }

  function closeModal() {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  // --- Close modal ---
  modal.addEventListener('click', (e) => {
    if (e.target.closest('[data-login-close]')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.style.display !== 'none') {
      closeModal();
    }
  });

  // --- Tab switching ---
  modal.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-login-tab]');
    if (!tab) return;

    const value = tab.getAttribute('data-login-tab');

    modal.querySelectorAll('[data-login-tab]').forEach((t) => {
      t.classList.toggle('login__tab--active', t.getAttribute('data-login-tab') === value);
    });

    modal.querySelectorAll('[data-login-panel]').forEach((p) => {
      p.classList.toggle('login__panel--active', p.getAttribute('data-login-panel') === value);
    });
  });

  // --- Accordion ---
  modal.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-login-accordion]');
    if (!trigger) return;

    trigger.classList.toggle('login__accordion-trigger--open');
    const body = trigger.nextElementSibling;
    if (body && body.classList.contains('login__accordion-body')) {
      body.classList.toggle('login__accordion-body--open');
    }
  });

  // --- AJAX login ---
  if (loginForm) {
    loginForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      clearAlert();

      const formData = new FormData(loginForm);

      try {
        const response = await fetch('/aio/login', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        });

        const text = await response.text();
        let json = null;

        try {
          json = JSON.parse(text);
        } catch {
          // not JSON
        }

        if (json && json.error) {
          showAlert(json.error, 'error');
        } else if (!json && text.length > 200) {
          showAlert(text, 'error');
        } else {
          window.location.reload();
        }
      } catch {
        showAlert('Chyba pripojeni. Zkuste to znovu.', 'error');
      }
    });
  }

  function showAlert(message, type) {
    if (!loginAlert) return;
    loginAlert.textContent = message;
    loginAlert.className = 'login__alert login__alert--' + type;
  }

  function clearAlert() {
    if (!loginAlert) return;
    loginAlert.textContent = '';
    loginAlert.className = '';
  }
}
